import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint react-hooks/exhaustive-deps: "error" */
import { useRef, useCallback, useState } from 'react';
import useInterval from "./useInterval";
var BASE_CONFIG = {
  height: 500,
  width: 700,
  location: 'no',
  toolbar: 'no',
  status: 'no',
  directories: 'no',
  menubar: 'no',
  scrollbars: 'yes',
  resizable: 'no',
  centerscreen: 'yes',
  chrome: 'yes'
};
function useWindowPopUp(url) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var windowRef = useRef(null);
  var interval = isOpen ? 1000 : null;
  var handler = useCallback(function () {
    windowRef.current = window.open(url, 'ChatPopup', Object.entries(_objectSpread(_objectSpread({}, BASE_CONFIG), config)).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return "".concat(key, "=").concat(value);
    }).join(', '));
    setIsOpen(windowRef.current !== null);
  }, [config, url]);
  var closeWindow = function closeWindow() {
    if (windowRef.current && windowRef.current.closed === false) {
      windowRef.current.close();
    }
  };
  useInterval(function () {
    return setIsOpen(!!windowRef.current && windowRef.current.closed === false);
  }, interval);
  return [{
    isOpen: isOpen,
    windowRef: windowRef,
    closeWindow: closeWindow
  }, handler];
}
export default useWindowPopUp;